import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Base de origen para los componentes que aún construyen URLs absolutas
// (axios directo, fetch, sendBeacon, WebSocket). Vacía = relativa al mismo
// origen: funciona igual en securegatecard.nordicbyte.co.uk que en
// panel.securegatecard.nordicbyte.co.uk sin tocar nada por host.
export const API_BASE = '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Global interceptors registered on the default axios instance do NOT apply
// to instances from axios.create(); attach the session token here too.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Cards API
export const cardsAPI = {
  register: (data) => api.post('/auth/register-card', data),
  get: (rfidId, pin) => api.get(`/cards/${rfidId}`, { params: { pin } }),
  update: (rfidId, data) => api.put(`/cards/${rfidId}`, data),
  delete: (rfidId) => api.delete(`/cards/${rfidId}`),
  list: () => api.get('/cards')
};

// Data API
export const dataAPI = {
  save: (data) => api.post('/data/save', data),

  upload: (formData) => api.post('/data/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  /**
   * List data with pagination. Supports cursor-based pagination for performance.
   * @param {string} rfidId
   * @param {object} opts - { page, limit, light, cursor_created_at, cursor_id }
   */
  list: (rfidId, opts = {}) => {
    const params = { light: '1', ...opts };
    return api.get(`/data/${rfidId}`, { params });
  },

  get: (id, rfidId) => api.get(`/data/item/${id}`, { params: { rfidId } }),

  download: (id, rfidId) => {
    return api.get(`/data/download/${id}`, {
      params: { rfidId },
      responseType: 'blob'
    });
  },

  delete: (id, rfidId) => api.delete(`/data/${id}`, { params: { rfidId } }),

  update: (id, data) => api.put(`/data/${id}`, data),

  // Contadores por categoría/tag/bóveda de toda la cuenta (no solo la página
  // cargada). Ver GET /data/:rfidId/stats en server/routes/data.js.
  stats: (rfidId) => api.get(`/data/${rfidId}/stats`)
};

// Vaults API
export const vaultsAPI = {
  list: (rfidId) => api.get('/vaults', { params: { rfidId } }),
  create: (data) => api.post('/vaults', data)
};

export default api;
